import { createAction } from 'redux-actions';

export const SET_SELECTED_SEGMENT_ID = 'SEAT_MAP/SET_SELECTED_SEGMENT_ID';
export const SET_NEXT_SEGMENT_ID = 'SEAT_MAP/SET_NEXT_SEGMENT_ID';

export const setSelectedSegmentId = createAction<number>(SET_SELECTED_SEGMENT_ID);

export type SetSelectedSegmentId = ReturnType<typeof setSelectedSegmentId>;

export const setNextSegmentId = createAction(SET_NEXT_SEGMENT_ID);

export type SetNextSegmentId = ReturnType<typeof setNextSegmentId>;
